import { useNavigate, useRouteError } from 'react-router-dom';
import Convert from 'ansi-to-html';
import StackTracey from 'stacktracey';
import { Button } from 'src/components/ui/button';
import { PATH_HOME } from 'src/constants/spa-routes';
import React from 'react';

const convert = new Convert({ newline: true, escapeXML: true });

export const MainErrorElement = () => {
  const navigate = useNavigate();
  const error: any = useRouteError();
  const stack = new StackTracey(error).withSources().clean();
  let msg;
  try {
    msg = convert.toHtml(error?.message);
  } catch (err: any) {
    msg = convert.toHtml(err?.message);
  }

  const goHome = () => {
    navigate(PATH_HOME.ROOT);
  };
  return (
    <div
      className={
        'w-[100vw] min-h-[100vh] flex flex-col bg-[linear-gradient(23deg,#F6FFE8_0.5%,#E2FFEC_25.51%,#E2F9FF_58.74%,#E5F1FE_98.59%)]'
      }
    >
      <div className={'flex p-8'}>
        <a href={'/'} className={'cursor-pointer group'}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="20"
            viewBox="0 0 33 20"
            fill="none"
          >
            <path
              d="M9.99343 -1.95063e-05C7.35999 -1.93923e-05 4.77036 1.05354 2.90824 2.9289C1.04613 4.80425 -3.59335e-07 7.34778 -4.41153e-07 9.99993C-5.2297e-07 12.6521 1.04613 15.1956 2.90824 17.071C4.77036 18.9463 7.36 19.9999 9.99343 19.9999L9.99343 9.99993L9.99343 -1.95063e-05Z"
              fill="#05050D"
              className={'group-hover:fill-[#05050DB2]'}
            />
            <path
              d="M22.7549 0C28.2741 0 32.749 4.47718 32.749 10C32.749 15.5228 28.2741 20 22.7549 20C17.2358 19.9999 12.7617 15.5227 12.7617 10C12.7617 4.47727 17.2358 0.000142861 22.7549 0ZM22.7334 5.9043C20.4756 5.9043 18.6446 7.73581 18.6445 9.99512C18.6445 12.2545 20.4755 14.0859 22.7334 14.0859C24.9911 14.0858 26.8213 12.2544 26.8213 9.99512C26.8213 7.73589 24.9911 5.90444 22.7334 5.9043Z"
              fill="#05050D"
              className={'group-hover:fill-[#05050DB2]'}
            />
          </svg>
        </a>
      </div>
      <div className={'flex flex-1 flex-col w-full items-center justify-center'}>
        <div>
          <p className={'text-[50px] font-semibold'}>⚠️</p>
        </div>
        <div>
          <p className={'text-3xl text-ebony font-semibold'}>Something went wrong</p>
        </div>
        <div
          className={
            'flex flex-col gap-2 mt-5 p-5 bg-[#FFFFFF66] border border-[#FFFFFF] rounded-sm-5 min-w-[50%]'
          }
        >
          {stack.items[0] && (
            <>
              <h4 className={'text-ebony_opacity_70 text-sm font-semibold'}>An error occurred:</h4>
              <div
                className={
                  'whitespace-break-spaces p-2 font-[monospace] bg-[#eeeeee] text-[#721c24] rounded-sm-5'
                }
                dangerouslySetInnerHTML={{ __html: msg }}
              />
              <h5 className={'text-ebony_opacity_70 text-sm font-semibold'}>Component Stack:</h5>
              <pre
                className={
                  'whitespace-break-spaces p-2 font-[monospace] bg-[#eeeeee] text-[#721c24] rounded-sm-5 overflow-x-auto'
                }
              >
                <div>
                  {stack.items[0].fileName}:{stack.items[0].line}: - {stack.items[0].callee}
                </div>
              </pre>
              <div
                className={
                  'whitespace-break-spaces p-2 font-[monospace] bg-[#eeeeee] text-[#721c24] rounded-sm-5'
                }
                dangerouslySetInnerHTML={{ __html: error?.stack }}
              />
            </>
          )}
          <div className={'flex items-center justify-center'}>
            <Button onClick={goHome} className={'w-56'} size={'xl'}>
              Go to Home
            </Button>
          </div>
        </div>
      </div>
      <div className={'flex w-full items-center justify-center p-10'}>
        <p className="opacity-50 text-xs font-jamjuree font-medium">
          CoSupport AI © {new Date().getFullYear()}.{' '}
          <a
            className="underline"
            href="https://cosupport.ai/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>{' '}
          &{' '}
          <a
            className="underline"
            href="https://cosupport.ai/terms-of-services"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </a>
        </p>
      </div>
    </div>
  );
};
